import { render, staticRenderFns } from "./NeedItem.vue?vue&type=template&id=2686396b&scoped=true&"
import script from "./NeedItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2686396b",
  null
  
)

export default component.exports